import defaultTo from 'ramda/es/defaultTo';
import prop from 'ramda/es/prop';

export const defaultToArray = defaultTo([]);

export const propData = prop('data');
